module.exports = __webpack_public_path__ + "media/customizations/valenciatrails/back-4dff2342dca7e3e12f31fef7f1ca6d07.jpg";